import {Injectable} from '@angular/core';
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class HistoryHelperService {

  public static readonly URL_KEY = 'urlToAccess';
  historyMap = new Map();

  constructor(private router: Router) {
  }

  storeHistory(key: string, history: any) {
    this.historyMap.set(key.toLowerCase(), history);
  }

  getHistory(key: string) {
    return this.historyMap.get(key.toLowerCase());
  }

  hasHistory(key: string){
    return this.historyMap.has(key.toLowerCase());
  }

  deleteHistory(key: string){
    this.historyMap.delete(key.toLowerCase());
  }

  navigateBack(){
    if (this.hasHistory('urlToAccess') && this.getHistory('urlToAccess').indexOf('request-details') > -1) {
      const url = this.getHistory('urlToAccess');
      this.deleteHistory('urlToAccess');
      this.router.navigateByUrl(url);
    } else { // default
      this.router.navigateByUrl('/user/home');
    }
  }

}
